import React from "react";
import { Box, Typography } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";

interface CardLabeledValueProps {
  label: string;
  value: React.ReactNode;
  sx?: object;
}

/**
 * An inline `Label: value` pair, sized to sit inside a card body. Inline, so a long value wraps to
 * the next line rather than truncating — the header has the room.
 *
 * `ProjectDetailRow` shows the same fields in the project list and truncates instead, because every
 * row there has to be one line. The two are not interchangeable.
 */
const CardLabeledValue: React.FC<CardLabeledValueProps> = ({ label, value, sx = {} }) => {
  return (
    <Box sx={{ mb: 0, ...sx }}>
      <Typography
        variant="caption"
        component="span"
        sx={{
          color: ediphiPalette.greyText,
          fontWeight: 600,
          display: "inline-block",
          marginRight: "4px",
        }}
      >
        {label}:
      </Typography>
      <Typography
        variant="body2"
        component="span"
        sx={{
          color: ediphiPalette.mainTextColor,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default CardLabeledValue;
